<script>
  if (self == top) {
    var antiClickjack = document.getElementById('antiClickjack');
    antiClickjack.parentNode.removeChild(antiClickjack);
  } else {
    top.location = self.location;
  }
</script>
<div class="app-shell" [attr.inert]="dealerContextBlocked() ? '' : null">
  <app-big-dots-spinner [loading]="initialLoading()" [fullScreen]="true" />
  <app-loader [loading]="loading()" />
  <router-outlet />
</div>
<ph-dealer-context-block />
